export default __webpack_public_path__ + "static/blog3-8f5e1181169175e6412d82ebd866153b.png";